export * from './ProductTabsItem';
